import { SATOSPortal } from "@/data-adapter/SATOSPortal";
import { useMutation } from "@tanstack/react-query";

export const useMutateArchiveProcedurePdf = () => {
	const { mutateAsync: createArchivedProcedurePdf } = useMutation({
		mutationFn: (procedureId: number) => {
			return SATOSPortal.CreateArchivedProcedurePdf(procedureId);
		},
	});

	return createArchivedProcedurePdf;
};
